import React, { Component } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { endpoint } from '../helpers/constantes';
import { connect } from 'react-redux';
import  Navigation from './Navigation/Navigation';
import Select from 'react-select';
import { modificaLoader } from '../actions/LoaderActions';

class CadastroCaixa extends Component {
  constructor(props) {
    super(props);
    this.props.modificaLoader(true);
    this.state = {
      nome: '',
      isSearchable: true,
      isClearable: false,    
      isLoading: false,
      isRtl: false,
      isDisabled: false,
      Olts: [],
      Vlans: [],      
      OltSelected: '',
      VlanSelected: '',
      alert: {
        show: false,      
        title: 'Aviso',
        message: '',
        type: {
          warning: false,
          success: false,
          danger: false,
        }
      }
    }
    
    this.listaOlts();
    this.props.modificaLoader(false);
    
  }

  limpar = () => {
    this.setState({ nome: '', OltSelected: null, VlanSelected: null });
    document.getElementById("cad-cx").reset();
  }

  listaOlts = () => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${this.props.token}`)
    fetch(`${endpoint}/olts`, {
      method: "GET",
      headers: myHeaders,
    })
    .then(result => {
      if(result.ok){
        return result.json();
      }else{
        this.setState({
          alert: {
            show: true,
            title: 'Falha',
            message: result.statusText,
            type: {
              warning: true,
              success: false,
              danger: false,
            }
          }
        })
        throw Error(result.statusText);
      }
    })
    .then(resultJson => {
      const resultFormated = resultJson.map(item => {
        return {
          value: item.id,
          label: item.nome,
        }
      })
      this.setState({ Olts: resultFormated });    
    })
    .catch(err => {
      this.setState({
        alert: {
          show: true,
          title: 'Falha',
          message: err.message,
          type: {
            warning: false,
            success: false,
            danger: true,
          }
        }
      })
    })
  }

  listaVlans = (id) => {
    this.props.modificaLoader(true);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${this.props.token}`)
    fetch(`${endpoint}/vlans/olt/${id}`, {
      method: "GET",
      headers: myHeaders,
    })
    .then(result => {
      if(result.ok){
        this.props.modificaLoader(false);
     
        return result.json();
      }else{
        this.props.modificaLoader(false);
        this.setState({
          alert: {
            show: true,
            title: 'Falha',
            message: result.statusText,
            type: {
              warning: true,
              success: false,
              danger: false,
            }
          }
        })
        throw Error(result.statusText);
      }
    })
    .then(resultJson => {
      const resultFormated = resultJson.map(item => {
        return {
          value: item.id,
          label: item.vlan,
        }
      })
      this.setState({ Vlans: resultFormated });    
    })
    .catch(err => {
      this.props.modificaLoader(false);
      this.setState({
        alert: {
          show: true,
          title: 'Falha',
          message: err.message,
          type: {
            warning: false,
            success: false,
            danger: true,
          }
        }
      })
    })
  }

  cadastrar = (e) => {
    this.props.modificaLoader(true);
    e.preventDefault();
    if(!this.state.nome || !this.state.VlanSelected || !this.state.OltSelected) {
      this.setState({
        alert: {
          show: true,
          title: 'Para efetuar uma alteração é preciso preencher todos os campos',
          message: 'Existem campos obrigatórios em branco',
          type: {
            warning: false,
            success: false,
            danger: true,
          }
        }
      })
      return;
    }
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${this.props.token}`)
    fetch(`${endpoint}/caixa`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        nome: this.state.nome, 
        id_vlan: this.state.VlanSelected.value,
      })})    
    .then(result => {
      if (result.ok) {
        this.props.modificaLoader(false);
        this.setState({
          alert: {
            show: true,             
            title: 'Sucesso',
            message: result.statusText,
            type: {
              warning: false,
              success: true,
              danger: false,
            }
          }
        })
      }else{
        this.props.modificaLoader(false);
        this.setState({
          alert: {
            show: true,
            title: 'Falha',
            message: result.statusText,
            type: {
              warning: true,
              success: false,
              danger: false,
            }
          }
        })
      }
    })  
    .catch(err => {
      this.props.modificaLoader(false);
      this.setState({
        alert: {
          show: true,
          title: 'Erro! Estamos sem conectividade ?',
          message: err.message,
          type: {
            warning: false,
            success: false,
            danger: true,
          }
        }
      })
    })
  };

  handleChangeOlt = (selected) => {
    if(selected){
      this.setState({ OltSelected: selected, VlanSelected: null });
      this.listaVlans(selected.value);      
    }else{
      this.setState({ OltSelected: null });
    }
  }
  
  handleChangeVlan = (selected) => {
    if(selected){
      this.setState({ VlanSelected: selected });
    }else{
      this.setState({ VlanSelected: null });
    }
  }

  render() {
    return (
      <Navigation history={this.props.history}>
        <h1>Cadastre uma nova CTO ou CTOC</h1>
        <p style={{fontSize: '12px', color: '#aeaeae'}}>Caixas são vinculadas a uma vlan contida em uma OLT específica</p>            
        <form id="cad-cx" onSubmit={this.cadastrar}>
          <div className="form-group">
            Selecione uma OLT
            <Select
              value={this.state.OltSelected}
              className="basic-single"
              classNamePrefix="select"
              isDisabled={this.state.isDisabled}
              isLoading={this.state.isLoading}
              isClearable={this.state.isClearable}
              isRtl={this.state.isRtl}
              isSearchable={this.state.isSearchable}
              options={this.state.Olts}
              onChange={this.handleChangeOlt}              
            />            
            </div>         
          <div className="form-group">
            Selecione uma VLAN          
            <Select
              className="basic-single"
              classNamePrefix="select"              
              isDisabled={this.state.isDisabled}
              isLoading={this.state.isLoading}
              isClearable={this.state.isClearable}
              isRtl={this.state.isRtl}
              isSearchable={this.state.isSearchable}
              options={this.state.Vlans}
              onChange={this.handleChangeVlan}
              value={this.state.VlanSelected}
                          
            />
          </div>
          <div className="form-group">
            Caixa:
            <input 
            className="form-control" 
            type="text" 
            name="caixa" 
            value={this.props.caixa} 
            onChange={event => this.setState({nome: event.target.value})} 
            required/>
          </div>
          <div className="form-group">
            <button 
            className="btn btn-outline-danger" 
            type="submit" 
            name="Cadastrar">
            Cadastrar
            </button>
            <button 
            className="btn btn-outline-secondary ml-3" 
            type="button" 
            onClick={this.limpar} 
            name="Limpar">
            Limpar
            </button>
          </div>
        </form>
        <SweetAlert {...this.state.alert.type}
          title={this.state.alert.title}
          show={this.state.alert.show}
          onConfirm={() => {
            this.setState({ ...this.state, alert: {show: false, title: ''}})
            this.limpar();
          }}>
          {this.state.alert.message}
        </SweetAlert>
      </Navigation>
    );
  }
}
const mapStateToProps = state => ({
  token: state.LoginReducer.token,
});

export default connect(mapStateToProps, { modificaLoader})(CadastroCaixa);



// WEBPACK FOOTER //
// ./src/components/CadastroCaixa.js